import * as Sentry from '@sentry/react';
import {useEffect} from 'react';

import {useUserDetails} from '@/lib/auth/hooks';

import type {FC} from 'react';

export const SentryUserSync: FC = () => {
  const {user, email, org} = useUserDetails();

  useEffect(() => {
    Sentry.setTag('service', 'web');
  }, []);

  useEffect(() => {
    if (!user) {
      Sentry.setUser(null);
      Sentry.setTag('tenant', undefined);
      return;
    }
    Sentry.setUser({id: user.sub, email});
    Sentry.setTag('tenant', org?.id);
  }, [user, email, org]);

  return null;
};
